import React, { Component } from "react";
import withTracker from "../../components/Tracker/withTracker";
import { Route, Switch, withRouter } from "react-router-dom";
import Login from "../../views/Login/Login";
import Signup from "../../views/Signup/Signup";
import Plans from "../../views/Plans/Plans";
import PageNotFound from "../../views/Errors/404Error";
import Package from "../../views/Plans/SubscriptionPackageNew";
// import CustomPlanCalculator from "views/Plans/CustomPlanCalculator";
import ContactUs from "../../views/ContactUs/ContactUs";
import Loading from "../../components/Loading/Loading";
import Sidebar from "../../components/Sidebar/Sidebar";
import Chatbot from "../../views/Chatbot/Chatbot";
import "../../assets/css/cookiepopup.css";

class LoginAndSignUpRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      showCookieBox: true, // Add showCookieBox state
    };
  }

  componentDidMount() {
    // Simulate a delay for the loading screen
    setTimeout(() => {
      this.setState({ loading: false });
    }, 2000); // Specify the desired delay in milliseconds
  }

  handleAccept = () => {
    // Create a cookie when the "I understand" button is clicked
    const expirationDate = new Date();
    expirationDate.setMonth(expirationDate.getMonth() + 2); // Set the expiration date to two months from now
    document.cookie = `cookieAccepted=true; expires=${expirationDate.toUTCString()}`;
    this.setState({ showCookieBox: false });
  };

  shouldShowCookieBox = () => {
    // Check if the cookie has been set
    return document.cookie.indexOf("cookieAccepted=true") === -1;
  };

  render() {
    const { location } = this.props;
    const { loading, showCookieBox } = this.state;

    if (loading) {      const centerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', 
      };
    
      return (
        <div style={centerStyle}>
          <Loading />
        </div>
      );
    }
    // Only render the sidebar for certain routes
    // Do not render a second Sidebar on root or auth pages
    const showSidebar =
      location.pathname !== "/" &&
      location.pathname !== "/login" &&
      location.pathname !== "/signup" &&
      location.pathname !== "/package";
      return (
        <React.Fragment>
        {showSidebar && <Sidebar />}
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/signup" component={withTracker(Signup)} />
          <Route exact path="/package" component={withTracker(Package)} />
          {/* <Route exact path="/plancalc" component={withTracker(CustomPlanCalculator)}/> */}
          <Route exact path="/contactUs" component={withTracker(ContactUs)} />
          <Route exact path="/" component={Login} />
          <Route component={Login} />
          {showCookieBox && this.shouldShowCookieBox() && (
            <div className="cookiebox">
              <div className="cookieboxcontent">
                <header>Cookies Consent</header>
                <p>This website uses cookies to ensure you get the best experience on our website.</p>
                <div className="cookieboxbuttons">
                  <button className="item" onClick={this.handleAccept}>
                    I understand
                  </button>
                  <a href="https://www.kaspersky.com/resource-center/definitions/cookies" className="item2">
                    Learn more
                  </a>
                </div>
              </div>
            </div>
          )}
        </Switch>
        {/* <Chatbot/> */}
        </React.Fragment>
      );
  }
}

export default withRouter(LoginAndSignUpRoute);
